import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]

  submitEnd({ detail: { success, fetchResponse } }) {
    if (!success && !fetchResponse) {
      this.statusTarget.textContent = "L’envoi n’a pas pu être confirmé. Votre texte est conservé ; vérifiez votre connexion puis réessayez."
    }
  }
}
